import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FeatureFlagService } from '@cia-front-end-apps/shared/feature-flag/feature-flag.service';
import { ProgressBarService } from '@cia-front-end-apps/shared/progress-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'hq-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginPageComponent implements OnInit, OnDestroy {
    serviceOutageMessage = '';
    private unsubscribe = new Subject<void>();

    constructor(
        private cdRef: ChangeDetectorRef,
        private featureFlagService: FeatureFlagService,
        private progressBarService: ProgressBarService
    ) {
    }

    ngOnInit(): void {
        this.progressBarService.finishLoadingAnimation();

        this.featureFlagService.getFlag('cia-service-outage')
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(flag => {
                this.serviceOutageMessage = flag;
                this.cdRef.detectChanges();
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
